export const fileMasiveConstants = {
    
    FILE_SEARCH_MASIVE_REQUEST: 'FILE_SEARCH_MASIVE_REQUEST',
    FILE_SEARCH_MASIVE_SUCCESS: 'FILE_SEARCH_MASIVE_SUCCESS',
    FILE_SEARCH_MASIVE_FAILURE: 'FILE_SEARCH_MASIVE_FAILURE',

    UPLOAD_SIGN_MASIVE_REQUEST: 'UPLOAD_SIGN_MASIVE_REQUEST',
    UPLOAD_SIGN_MASIVE_SUCCESS: 'UPLOAD_SIGN_MASIVE_SUCCESS',
    UPLOAD_SIGN_MASIVE_FAILURE: 'UPLOAD_SIGN_MASIVE_FAILURE',
    UPLOAD_SIGN_MASIVE_RESET: 'UPLOAD_SIGN_MASIVE_RESET',

/* --------------------------------------------------------------------- */

    GET_BATCHFILE_REQUEST: 'GET_BATCHFILE_REQUEST',
    GET_BATCHFILE_SUCCESS: 'GET_BATCHFILE_SUCCESS',
    GET_BATCHFILE_FAILURE: 'GET_BATCHFILE_FAILURE',

    INITIALIZATE_BATCHFILE_REQUEST: 'INITIALIZATE_BATCHFILE_REQUEST',
    INITIALIZATE_BATCHFILE_SUCCESS: 'INITIALIZATE_BATCHFILE_SUCCESS',
    INITIALIZATE_BATCHFILE_FAILURE: 'INITIALIZATE_BATCHFILE_FAILURE',

    GET_USERS_SIGNS_MASIVE: 'GET_USERS_SIGNS_MASIVE',

    FILE_SEARCH_MASIVE_DEATILS_GROUP_REQUEST: 'FILE_SEARCH_MASIVE_DEATILS_GROUP_REQUEST',
    FILE_SEARCH_MASIVE_DEATILS_GROUP_SUCCESS: 'FILE_SEARCH_MASIVE_DEATILS_GROUP_SUCCESS',
    FILE_SEARCH_MASIVE_DEATILS_GROUP_FAILURE: 'FILE_SEARCH_MASIVE_DEATILS_GROUP_FAILURE',

    FILE_SEARCH_STATUS_MASIVE_REQUEST: 'FILE_SEARCH_STATUS_MASIVE_REQUEST',
    FILE_SEARCH_STATUS_MASIVE_SUCCESS: 'FILE_SEARCH_STATUS_MASIVE_SUCCESS',
    FILE_SEARCH_STATUS_MASIVE_FAILURE: 'FILE_SEARCH_STATUS_MASIVE_FAILURE',

    UPLOAD_DOCUMENTS_MASIVE_REQUEST: 'UPLOAD_DOCUMENTS_MASIVE_REQUEST',
    UPLOAD_DOCUMENTS_MASIVE_SUCCESS: 'UPLOAD_DOCUMENTS_MASIVE_SUCCESS',
    UPLOAD_DOCUMENTS_MASIVE_FAILURE: 'UPLOAD_DOCUMENTS_MASIVE_FAILURE',

    GET_USERS_METADATA_MASIVE_REQUEST: 'GET_USERS_METADATA_MASIVE_REQUEST',
    GET_USERS_METADATA_MASIVE_SUCCESS: 'GET_USERS_METADATA_MASIVE_SUCCESS',
    GET_USERS_METADATA_MASIVE_FAILURE: 'GET_USERS_METADATA_MASIVE_FAILURE',

    UPLOAD_METADATA_USERS_MASIVE_REQUEST: 'UPLOAD_METADATA_USERS_MASIVE_REQUEST',
    UPLOAD_METADATA_USERS_MASIVE_SUCCESS: 'UPLOAD_METADATA_USERS_MASIVE_SUCCESS',
    UPLOAD_METADATA_USERS_MASIVE_FAILURE: 'UPLOAD_METADATA_USERS_MASIVE_FAILURE',
}